<div class="header" [ngClass]="{open: isOpen == true, scroll: isScroll == true, fullpage: isFullpage == true, mopen: isMobileOn == true}" (mouseleave)="closeMenu()">
  <div class="wrap">

    <a routerLink="/main" class="top-logo">
      <!-- img src="/assets/images/logo.png" alt="로고" /-->
      <div class="img"></div>
    </a>
    <a class="tot-menu" *ngIf="!isFullpage && !isMobileOn" (click)="fullPage()">전체메뉴</a>

    <div class="gnb" [ngClass]="{mopen: isMobileOn == true}">
      <a class="close-menu" *ngIf="isFullpage || isMobileOn" (click)="closeMenu1();">닫기</a>
      <ul class="main-menu" (mouseenter)="expandMenu()">
        <li *ngFor="let menu of menuList; let i = index">
          <a class="cp" [ngClass]="{on: menu_on == i.toString()}" (click)="goLink($event, [menu], i)">
            {{menu['page_menu_name']}}<span class="dot"></span>
          </a>

          <ul class="sub-menu" [ngClass]="{'sub-menu-even': (i % 2)==1}">
            <ng-container *ngIf="menu['children']">
            <li *ngFor="let item of menu['children']">
              <ng-container *ngIf="checkLevel(item) == true">
                <ng-container *ngIf="item.link_open_yn == 'N'">
                  <ng-container *ngIf="item.link_url.includes('http'); else route">
                    <a [href]="item.link_url" target="_blank">{{item.page_menu_name}}</a>
                  </ng-container>
                  <ng-template #route>
                    <a [routerLink]="item.link_url" target="_blank">{{item.page_menu_name}}</a>
                  </ng-template>
                </ng-container>

                <ng-container *ngIf="item.link_open_yn == 'C'">
                  <a [routerLink]="" (click)="goLink($event, [item], -1)">{{item.page_menu_name}}</a>
                </ng-container>
              </ng-container>
            </li>
            </ng-container>
          </ul>
        </li>
      </ul>

      <ul class="util-menu" *ngIf="isLogin$ | async as isLogin; else notLogin">
        <li><a class="cp" (click)="setLogout()">로그아웃</a></li>
        <li><a routerLink="/member/mypage/edit">회원정보수정</a></li>
				<li><a routerLink="/en" class="eng">ENG</a></li>
      </ul>
      <ng-template #notLogin>
        <ul class="util-menu">
          <li><a routerLink="/member/login">로그인</a></li>
          <li><a routerLink="/member/join">회원가입</a></li>
          <li><a routerLink="/en" class="eng">ENG</a></li>
        </ul>
      </ng-template>
    </div>
  </div>
</div>

<div class="panel-overlay" *ngIf="isMobileOn" (click)="isMobileOn = false"></div>

<!-- 아이폰 오류로 추가 -->
<a routerLink="/main" class="mobile-logo top-logo" [ngClass]="{mopen: isMobileOn == true}">
  <img src="assets/images/logo.png" alt="로고" />
</a>
